import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/**
 * Settings -> Policies -> Agent Autonomy (v4/api, `App\Settings\Autonomy\
 * AutonomySettings`): ce arata `Autonomy::index` si cele 15 scrieri ale
 * lui, cu aceleasi campuri si aceleasi raspunsuri `{ok, error?}`.
 */
const BASE = '/settings/autonomy'

export type Answer = { ok: boolean; error?: string; id?: number; added?: number; count?: number; hits?: PreviewHit[] }
export type Row = Record<string, unknown>

export interface PreviewHit {
  device_id: number
  device: string
  n: number
}

export interface AutonomyPage {
  ready: boolean
  switchedOn: boolean
  sensors: Row[]
  sensorsReady: boolean
  playbookReady: boolean
  runbooks: Row[]
  library: Record<string, Row>
  dailyCap: number | null
  isGlobal: boolean
  rules: Row[]
  canScope: boolean
  overrides: Record<string, Row>
  recent: Row[]
  catalog: Row[]
  notifyEmail: string
  autoDiagnose: boolean | null
  companyId: number
  companyName: string
  response: {
    ready: boolean
    scope: 'company' | 'sp'
    sp: number
    matrix: Record<string, Row>
    overrides: Row[]
    types: Row[]
    people: Row[]
    recent: Row[]
    today: Row
    severities: Record<string, string>
  }
  desk: {
    ready: boolean
    scope: 'company' | 'sp'
    sp: number
    policy: Row
    own: boolean
    recent: Row[]
    today: Row
    aiReady: boolean
  }
  deskPaused?: {
    paused: boolean
    by: number
    at: string | null
    reason: string
  }
  heartbeat?: {
    tick: string
    started_at: string | null
    finished_at: string | null
    last_ok_at: string | null
    last_error: string | null
    stale: boolean
  }[]
}

export function autonomyQuery(scope: string, dscope: string) {
  const p = new URLSearchParams()
  if (scope) p.set('scope', scope)
  if (dscope) p.set('dscope', dscope)
  const q = p.toString()
  return queryOptions({
    queryKey: ['settings', 'autonomy', scope, dscope],
    queryFn: () => apiGet<AutonomyPage>(BASE + (q ? `?${q}` : '')),
  })
}

export const autonomyPost = (path: string, fields: Record<string, PostValue>) => apiPost<Answer>(`${BASE}${path}`, fields)
